// MUI
import { TableCell } from "@mui/material";

// Helpers
import { printMonthDay } from "../helpers/methods";

// Components
import ItemDescriptionWithImageForDo from "../Order/ItemDescriptionWithImageForDo";

// Styles
import "./Order/BulkPrintDeliveryOrder/pagebreak.css";

const CountCell = ({ idx }) => (
  <TableCell align="center" padding="none" size="small">
    {idx + 1}
  </TableCell>
);

const DescriptionCell = ({ description }) => (
  <TableCell>{description}</TableCell>
);

const DescriptionWithImageCell = ({ description, images }) => (
  <TableCell>
    <ItemDescriptionWithImageForDo
      description={description}
      images={images || null}
    />
  </TableCell>
);

const DescriptionWithQuantityCell = ({ description, quantity }) => (
  <TableCell>{`${description} x${quantity}`}</TableCell>
);

const KeywordCell = ({ keyword }) => <TableCell>{keyword || ""}</TableCell>;

const SkuCell = ({ sku }) => <TableCell>{sku || ""}</TableCell>;

const DetailCell = ({ detail }) => <TableCell>{detail || ""}</TableCell>;

const UnitPriceCell = ({ unitPrice }) => <TableCell>{unitPrice}</TableCell>;

const QuantityCell = ({ quantity }) => <TableCell>{quantity}</TableCell>;

const SubtotalCell = ({ price }) => <TableCell>{price}</TableCell>;

const OrderedCell = ({ createdAt }) => (
  <TableCell style={{ whiteSpace: "nowrap" }}>
    {printMonthDay(createdAt)}
  </TableCell>
);

const NotesCell = () => <TableCell></TableCell>;

export const DefaultCell = () => <TableCell>—</TableCell>;

// Renderer map linking column keys to cell components
export const cellRenderers = {
  count: ({ idx }) => <CountCell idx={idx} />,
  description: ({ row }) => <DescriptionCell description={row.description} />,
  descriptionWithImage: ({ row }) => (
    <DescriptionWithImageCell
      description={row.description}
      images={row?.keyword?.images}
    />
  ),
  descriptionWithQuantity: ({ row }) => (
    <DescriptionWithQuantityCell
      description={row.description}
      quantity={row.quantity}
    />
  ),
  keyword: ({ row }) => <KeywordCell keyword={row?.keyword?.key} />,
  sku: ({ row }) => <SkuCell sku={row?.keyword?.sku} />,
  detail: ({ row }) => <DetailCell detail={row?.keyword?.detail} />,
  unitPrice: ({ row }) => <UnitPriceCell unitPrice={row.unitPrice} />,
  quantity: ({ row }) => <QuantityCell quantity={row.quantity} />,
  subtotal: ({ row }) => <SubtotalCell price={row.price} />,
  ordered: ({ row }) => <OrderedCell createdAt={row.createdAt} />,
  notes: () => <NotesCell />,
};

// Main refactored TableBody rendering using dynamic renderers

{
  /* <TableBody>
  {itemWithDescriptions.map((row, idx) => (
    <TableRow key={idx}>
      {columns.map((col) => {
        export const Renderer = cellRenderers[col.key] || DefaultCell;
        return (
          <React.Fragment key={col.key}>
            {Renderer({ row, idx, printMonthDay })}
          </React.Fragment>
        );
      })}
    </TableRow>
  ))}
</TableBody>; */
}
